import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const ArrowLeft = ({
  size,
  type,
  theme,
  className,
  dataTestId = "arrow-left-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M7.40614 11.7908C7.66649 12.0511 7.66649 12.4732 7.40614 12.7336C7.14579 12.9939 6.72368 12.9939 6.46333 12.7336L2.20138 8.47162C1.94103 8.21127 1.94103 7.78916 2.20138 7.52881L6.46333 3.26686C6.72368 3.00651 7.14579 3.00651 7.40614 3.26686C7.66649 3.52721 7.66649 3.94932 7.40614 4.20967L4.28203 7.33378L13.328 7.33378C13.6962 7.33378 13.9946 7.63226 13.9946 8.00045C13.9946 8.36864 13.6962 8.66711 13.328 8.66711L4.28249 8.66711L7.40614 11.7908Z" />
  </SVGIcon>
);
